export default defineNuxtPlugin(() => {
  const { get, post, patch, put, delete: $delete } = useRequest()

  return {
    provide: {
      http: {
        get,
        post,
        patch,
        put,
        $delete,
      },
    },
  }
})
